// extracted by mini-css-extract-plugin
export default {"helper":"_3leLfRZm","sentText":"UG3zKvsk"};